import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "form"]

  toggleEdit() {
    this.displayTargets.forEach(element => {
      element.classList.add("hidden")
    })
    this.formTargets.forEach(element => {
      element.classList.remove("hidden")
    })
  }

  cancelEdit() {
    this.formTargets.forEach(element => {
      element.classList.add("hidden")
    })
    this.displayTargets.forEach(element => {
      element.classList.remove("hidden")
    })
  }
}